import { createContext, useCallback, useContext, useMemo, useState } from "react";

const FeedbackContext = createContext({ notify: () => {} });

export function useFeedback() {
  return useContext(FeedbackContext);
}

export default function FeedbackProvider({ children }) {
  const [messages, setMessages] = useState([]);

  const dismiss = useCallback((id) => {
    setMessages((current) => current.filter((message) => message.id !== id));
  }, []);

  const notify = useCallback((message, type = "info") => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    setMessages((current) => [...current, { id, message, type }]);
    window.setTimeout(() => dismiss(id), 6000);
  }, [dismiss]);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <FeedbackContext.Provider value={value}>
      {children}
      <div className="cg-notification-stack" aria-live="polite" aria-atomic="false">
        {messages.map((message) => (
          <div key={message.id} className={`cg-notification ${message.type}`} role="status">
            <span>{message.message}</span>
            <button type="button" onClick={() => dismiss(message.id)} aria-label="Dismiss notification">
              &times;
            </button>
          </div>
        ))}
      </div>
    </FeedbackContext.Provider>
  );
}
